import { decrypt } from "../utils/cryptoHelper";

export const useProject = () => {
  if (window.localStorage.getItem("project")) {
    return JSON.parse(decrypt(window.localStorage.getItem("project")));
  } else return undefined;
};
